import { atomWithStorage } from "jotai/utils";

import type { Settings, Story, StoryTrack } from "@baiki/interfaces";

// Player settings and state (persisted)
interface PlayerStorage {
  loop: boolean;
  playbackRate: number;
  track: StoryTrack | null;
}

const PLAYER_DEFAULTS: PlayerStorage = {
  loop: false,
  playbackRate: 1,
  track: null,
};
const player = atomWithStorage<PlayerStorage>("player", PLAYER_DEFAULTS);

// Settings
const SETTINGS_DEFAULTS: Settings = {
  language: undefined, // Will be determined by browser/i18n
};
const settings = atomWithStorage<Settings>("settings", SETTINGS_DEFAULTS);

// Minimal story type for localStorage (excludes large text content)
// This significantly reduces localStorage usage
export type MinimalStory = Omit<Story, "content"> & {
  content: Omit<Story["content"], "text"> & { text?: never };
};

// Helper to convert Story to MinimalStory
export const toMinimalStory = (story: Story | null): MinimalStory | null => {
  if (!story) return null;
  const { text: _text, ...contentWithoutText } = story.content;
  return {
    ...story,
    content: contentWithoutText as MinimalStory["content"],
  };
};

// story - store minimal version without text content to save localStorage space
const STORY_DEFAULTS: MinimalStory | null = null;
const story = atomWithStorage<MinimalStory | null>("story", STORY_DEFAULTS);

export const Storage = {
  player,
  settings,
  story,
};
